// guards/read-only-route.guard.ts
import { inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ReadOnlyUserService } from '../other/read-only-user.service';
export const readOnlyRouteGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const readOnlyUserService = inject(ReadOnlyUserService);
  const router = inject(Router);

  // Check if user can access this route
  const canAccess = readOnlyUserService.canAccessRoute(state.url);

  if (canAccess) {
    return true;
  }

  // Redirect to minutes list if access denied
  return router.createUrlTree(['/main/minutes']);
};
